import { customAxios } from './customAxios'
export function annullamentoPratica(idPratica) {
  const config = {
    params: {
      idAdeguataVerifica: idPratica,
    },
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }
  const annullaPratica = customAxios.post(
    process.env.REACT_APP_BACKEND_HOST +
      '/' +
      process.env.REACT_APP_PATH_NEW_PREFIX +
      '/annullamentoPratica?',
    null,
    config,
  )
  return annullaPratica
}
